<template>
  <div class='operation' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='80px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='委托商:'>
          <el-input v-model='form.consignorName' size='mini' placeholder='请输入委托商'></el-input>
        </el-form-item>
        <el-form-item label='供应商:'>
          <el-input v-model='form.supplierName' size='mini' placeholder='请输入供应商'></el-input>
        </el-form-item>
        <el-form-item label='港口名称:'>
          <el-input v-model='form.portName' size='mini' placeholder='请输入港口名称'></el-input>
        </el-form-item>
        <el-form-item label='批次号:'>
          <el-input v-model='form.batchNumber' size='mini' placeholder='请输入批次号'></el-input>
        </el-form-item>
        <el-form-item label='运单编号:'>
          <el-input v-model='form.waybillNo' size='mini' placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='车架号:'>
          <el-input v-model='form.frameNumber' size='mini' placeholder='请输入车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}"></el-input>
        </el-form-item>
        <el-form-item label='补结算对账编号：' label-width="130px">
          <el-input v-model='form.actNoAdd' size='mini' placeholder='请输入补结算对账编号'  style="width: 170px"/>
        </el-form-item>
        <el-form-item label='补结算对账标题： ' label-width="130px">
          <el-input v-model='form.titleAdd' size='mini' placeholder='请输入补结算对账标题' />
        </el-form-item>
        <el-form-item label='作业时间:'>
          <el-date-picker
            v-model='operationDate'
            type='daterange'
            range-separator='-'
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style='width: 220px;'
            start-placeholder='开始日期'
            end-placeholder='结束日期' size='mini'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='作业类型:'>
          <el-select v-model='form.workType' filterable size='mini' placeholder='请选择作业类型'>
            <el-option value='' label='全部'></el-option>
            <el-option value='1' label='装车'></el-option>
            <el-option value='2' label='卸车'></el-option>
            <el-option value='3' label='过驳'></el-option>
            <el-option value='4' label='转船'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='结算方式:'>
          <el-select v-model='form.type' filterable size='mini' placeholder='请选择结算方式'>
            <el-option value='' label='全部'></el-option>
            <el-option value='0' label='合同'></el-option>
            <el-option value='1' label='预结算'></el-option>
            <el-option value='2' label='预估算'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='台账月:'>
          <el-input v-model='form.standingBookMonth' size='mini'
                    placeholder='请输入台账月'></el-input>
        </el-form-item>
        <el-form-item label='品牌:'>
          <el-input v-model='form.brandName' size='mini' placeholder='请输入品牌'></el-input>
        </el-form-item>
        <el-form-item label='船舶名称:'>
          <el-input v-model='form.personnelName' size='mini'
                    placeholder='请输入船舶名称'></el-input>
        </el-form-item>
        <el-form-item label='航次:'>
          <el-input v-model='form.voyageNumber' size='mini' placeholder='请输入航次'></el-input>
        </el-form-item>
        <el-form-item label='是否生成对账单:' label-width='130px'>
          <el-select v-model='form.isReconciliation' filterable size='mini'
                     placeholder='请选择是否生成对账单'>
            <el-option label='全部' value=''></el-option>
            <el-option label='是' value='1'></el-option>
            <el-option label='否' value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='是否生成补结算:' label-width='130px'>
          <el-select v-model='form.isAdd' size='mini' placeholder='请选择是否生成补结算'>
            <el-option label='全部' value='' />
            <el-option label='是' :value='1' />
            <el-option label='否' :value='0' />
          </el-select>
        </el-form-item>
        <el-form-item class='buttonClass'>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='addResetBtn'>刷新结算</el-button>
<!--          <el-button size='small' type='primary' @click='ledgerRevise'>修改台账月</el-button>-->
          <el-button size='small' type='primary' @click='download(true)'>码头模板</el-button>
          <operation-batch-import class='ml10'
                                  :uploadUrl='"/platform/settlement/supplierPortOperation/exportWithImport"'
                                  :uploadText='"转换模板"' :is-button='true' :button-size='"small"'
                                  @triggerLoading='importLoading = !importLoading'/>
          <el-button size='small' type='primary' @click='priceRefresh'>价格刷新</el-button>
        </el-form-item>

      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download(false)' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
        <import-statement @getList='_supplierPortOperationPageList'
                          @changeImportLoading='changeImportLoading' :type='6'/>
        </span>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          tooltip-effect='dark'
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :header-cell-style="{
            color:'#3B3B3B',
            'font-size':'13px',
            'height':'48px',
            background:'#E8E8E8'
          }"
          :cell-style="{height:'42px',}"
          :row-key='(row)=>{return row.id}'
          :reserve-selection='true'
          :row-style="rowStyle">
          <!-- :selectable="selectable" -->
          <el-table-column type='selection' align='center' width='50px' :reserve-selection='true'
                           :selectable='(row,index)=>{return row.isReconciliation !==1}'/>
          <el-table-column prop='consignorName' label='委托商' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='supplierName' label='供应商' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='personnelName' label='船舶名称' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='voyageNumber' label='航次' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='portName' label='港口名称' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='batchNumber' label='批次号' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='waybillNo' label='运单编号' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='frameNumber' label='车架号' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='workType' label='作业类型' align='center' width='80px'>
            <template slot-scope='scope'>{{ scope.row.workType|workTypeFormat }}</template>
          </el-table-column>
          <el-table-column prop='workDate' label='作业时间' align='center' width='120'
                           show-overflow-tooltip>
            <template slot-scope='scope'>{{ scope.row.workDate|formatTime }}</template>
          </el-table-column>
          <el-table-column prop='standingBookMonth' label='台账月' align='center' width='100'
                           show-overflow-tooltip>
            <!-- <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.sss" :disabled="scope.row.isReconciliation ===1 ?true : false"></el-input>
            </template> -->
          </el-table-column>
          <el-table-column prop='brandName' label='品牌' align='center'/>
          <el-table-column prop='modelName' label='型号' align='center'/>
          <el-table-column prop='taxRate' label='税率(%)' align='center'/>
          <el-table-column prop='taxContractPrice' label='含税合同价' align='center'/>
          <el-table-column prop='contractPrice' label='不含税合同价' align='center'/>
          <!--          <el-table-column prop="prepareType" label="预结算方式" align="center">-->
          <!--            <template slot-scope="scope">{{scope.row.prepareType |prepareTypeFormat}}</template>-->
          <!--          </el-table-column>-->
          <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center'/>
          <el-table-column prop='preparePrice' label='不含税预结算价' align='center' width='160px'/>
          <el-table-column prop='isAdd' label='是否生成补结算' align='center' width='160px'>
            <template slot-scope='scope'>{{ scope.row.isAdd|isAddFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='isReconciliation' label='生成对账单' align='center' width='90px'>
            <template slot-scope='scope'>{{ scope.row.isReconciliation|isReconciliationFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='settNo' label='对账单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='actNoAdd' label='补结算对账编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='titleAdd' label='补结算对账标题' width='160px' align='center'
                           show-overflow-tooltip/>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[50, 100, 500, 1000,5000]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <!-- 对账单 -->
    <el-dialog :title=" importShow ?'导入生成对账单':'生成对账单'" :visible.sync='addFlag'
               width='950px'
               center @close='dialogClose'>
      <operation-account-state
        :importShow='importShow'
        :dialog-close-parent='dialogClose'
        :settlement='settlement'
        @selectionTable='selectChange'
        ref='accountState'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单费用</template>
        <template slot='label3'>其他费用</template>
      </operation-account-state>
    </el-dialog>
    <el-dialog title='添加其他费用' :visible.sync='otherAddFlag' append-to-body width='750px'>
      <otherAdd @otherDataCelect='otherData' ref='otherAdds'
                :otherDateProps='JSON.parse(JSON.stringify(otherTableData))'
                :consignor-id='consignorId'></otherAdd>
    </el-dialog>

    <!-- 修改台账月 -->
    <el-dialog title='修改台账月' :visible.sync='ledgerVisible' width='1100px' center
               @close='ledgerClose'>
      <div class='ledger'>
        <div class='leader-input'>
          <span>请输入台账月：</span>
          <el-input size='small' type='text' v-model='ledger' style='display:inline-block'/>
          <div style='display:inline-block;width:calc(100% - 300px);text-align:right'>
            <el-button size='small' class='searchBtn' @click='ledgerChange'>确 定</el-button>
            <el-button size='small' class='resetBtn' @click='ledgerClose'>取 消</el-button>
          </div>
        </div>
        <el-table
          v-loading='ledgerLoad'
          :data='ledgerData'
          style='width: 100%'
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column prop='supplierName' label='供应商名称' min-width='100'
                           show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='portName' label='港口名称' min-width='100' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='batchNumber' label='批次号' min-width='150' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='waybillNo' label='运单编号' min-width='150' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='frameNumber' label='车架号' min-width='180' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='frameNumber' label='作业类型' min-width='150' show-overflow-tooltip
                           align='center'>
            <template slot-scope='scope'>{{ scope.row.workType|workTypeFormat }}</template>
          </el-table-column>
          <el-table-column prop='standingBookMonth' label='台账月' min-width='100'
                           show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='brandName' label='品牌' min-width='100' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='modelName' label='型号' min-width='120'
                           show-overflow-tooltip align='center'/>
          <el-table-column label='操作' align='center'>
            <template slot-scope='scope'>
              <i class='el-icon-error' style='font-size: 20px;'
                 @click='delLedger(scope.$index)'></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  supplierPortOperationPageList,
  customerAdd,
  deductionInvoicingCostGetAllByCompanyId,
  operationRefreshSettlement, operationUpdateBookMonth,
} from '@/service/getData';
import {formatTime, getSessionStore} from '@/config/mUtils';
import operationAccountState from '@/views/settle/supplier/components/operationAccountState.vue';
import otherAdd from './otherAdd.vue';
import {baseUrl} from '@/config/env';
import ImportStatement from '@/views/settle/entrust/components/import-statement';
import OperationBatchImport from './operation-components/operationBatchImport';
import {portOperatePriceRefreshRenovate} from '@/service/basicfile';

export default {
  components: {
    OperationBatchImport,
    ImportStatement,
    otherAdd,
    operationAccountState,
  },
  data() {
    return {
      form: {
        supplierName: '', // 供应商
        consignorName: '', //委托商
        type: '',//结算方式
        portName: '', // 港口名称
        waybillNo: '', // 运单编号
        workType: '', // 作业类型
        batchNumber: '', // 批次号
        frameNumber: '', // 车架号
        standingBookMonth: '', // 台账月
        brandName: '', // 品牌
        personnelName: '', // 品牌
        voyageNumber: '', // 品牌
        isReconciliation: '', // 是否生成账单
        isAdd: '', // 是否生成补结算
        actNoAdd: '', //补结算对账编号
        titleAdd: '',
        page: 1,
        rows: 50,
      },
      operationDate: ['', ''],
      total: 0,
      tableLoad: false,
      TableDatas: [],
      checkList: [], // 导入生成账单 选择数据
      visible: false, // 导入生成账单 筛选条件显示
      settlement: '',

      importShow: false,
      activeName: 'information', // 标签页
      otherAddFlag: false,
      isDisabled: false, // 是否启用合同价
      consignorId: '', // 公司id
      InvoicingList: [], // 抵扣费用下拉
      informationData: {
        supplier: '', // 供应商
        // Settlement:1,//结算方式
        sumIncluded: '', // 合计含税费用
        sumNotIncluded: '', // 合计不含税费用
        sumBudget: '', // 合计含税预结算费用
        sumNotBudget: '', // 合计不含税预结算费用
        title: '', //
        isInvoicing: 0, // 是否抵扣开票
        Invoicing: '', // 选择抵扣费用
        Deductible: '', // 抵扣费用
        remark: '',
      },
      checkLoad: false,
      notTableData: [],
      otherTableData: [],
      checkTableData: [],
      tipOne: true,
      otherIncluded: 0, // 其他费用合计
      otherNotIncluded: 0, // 其他费用合计
      sumContract: 0, // 作业费用合计
      sumNotIncluded: 0,
      sumBudget: 0,
      sumNotBudget: 0,
      oldSupplier: '', // 原供应商
      stepData: [
        {
          title: '张三发起',
          time: '2021-9-30 14:09:23',
          state: '',
          remark: '',
        },
        {
          title: '财务部 张三通过',
          time: '2021-9-30 14:09:23',
          state: 'success',
          remark: '原因xxxxxx',
        },
        {
          title: '技术部 李四拒绝',
          time: '2021-9-30 14:09:23',
          state: 'failure',
          remark: '原因xxxxxx',
        },
        {
          title: '张三重新发起',
          time: '2021-9-30 14:09:23',
          state: '',
          remark: '',
        },
      ],
      addFlag: false,
      rules: {
        plan: {
          required: true,
          message: ' ',
          trigger: 'blur',
        },
        name: [
          {
            required: true,
            message: '请输入业务名称',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 9,
            message: '长度在 3 到 9 个字符',
            trigger: 'blur',
          },
        ],
        content: {
          required: true,
          message: '请输入评审需求',
          trigger: 'blur',
        },
        type: {
          required: true,
          message: '请选择评审类型',
          trigger: 'blur',
        },
        img: {
          required: true,
          message: '请选择合同照片',
          trigger: 'blur',
        },
        title: {
          required: true,
          message: '请输入对账单标题',
          trigger: 'blur',
        },
        isInvoicing: {
          required: true,
          message: '请选择是否抵扣开票',
          trigger: 'blur',
        },
        Invoicing: {
          required: true,
          message: '请选择抵扣费用数据',
          trigger: 'blur',
        },
        Deductible: {
          required: true,
          message: '请输入抵扣费用',
          trigger: 'blur',
        },
        supplier: {
          required: true,
          message: '请输入供应商',
          trigger: 'blur',
        },
        // Settlement:{ required: true, message: '请选择结算方式', trigger: 'blur' },
      },
      // 修改台账月
      ledgerVisible: false,
      ledgerLoad: false,
      ledger: '',
      ledgerData: [],
      importLoading: false,
    };
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait';
          case 'success':
            return 'success';
          case 'failure':
            return 'error';
        }
      };
    },
    sumIncluded() {

    },
  },
  filters: {
    prepareTypeFormat(value) {
      switch (value) {
        case 1:
          return '固定';
        case 2:
          return '比例';
      }
    },
    isReconciliationFormat(value) {
      switch (value) {
        case 1:
          return '是';
        case 0:
          return '否';
      }
    },
    isAddFormat(value) {
      switch (value) {
        case 0:
          return '否';
        case 1:
          return '是';
        case null:
          return '否';
      }
    },
    formatTime(val) {
      if (val) {
        return formatTime(val, 'yyyy-mm-dd ');
      }
      return '';
    },
    workTypeFormat(value) {
      switch (value) {
        case 1:
          return '装车';
        case 2:
          return '卸车';
        case 3:
          return '过驳';
        case 4:
          return '转船';
      }
    },
  },
  watch: {
    // 监听已选择运单
    checkTableData(val) {
      console.log(val);
      // 运单费用含税费用
      this.sumContract = this.calculation(val, 'taxContractPrice');
      // 运单费用不含税费用
      this.sumNotIncluded = this.calculation(val, 'contractPrice');
      // 运单费用含税预结算费用
      this.sumBudget = this.calculation(val, 'taxPreparePrice');
      // 运单费用不含税预结算费用
      this.sumNotBudget = this.calculation(val, 'preparePrice');
      // 合计含税费用
      this.informationData.sumIncluded = this.sumContract + this.otherIncluded;
      // 合计不含税费用
      this.informationData.sumNotIncluded = this.sumNotIncluded + this.otherNotIncluded;
      // 合计含税预结算费用
      this.informationData.sumBudget = this.sumBudget + this.otherNotIncluded;
      // 合计不含税预结算费用
      this.informationData.sumNotBudget = this.sumNotBudget + this.otherNotIncluded;
      // 判断 不/含税合同价是否为空  是就禁用
      this.decideContract(val, this.otherTableData);
      this.informationData.supplier = this.oldSupplier = this.checkTableData.length > 0 ? this.checkTableData[0].portName : '';
    },
    otherTableData(val) {
      // 其他费用
      this.otherIncluded = this.calculation(val, 'costAmount');
      this.otherNotIncluded = this.calculation(val, 'excludingTaxAmount');
      // 合计含税费用
      this.informationData.sumIncluded = this.sumContract + this.otherIncluded;
      this.informationData.sumNotIncluded = this.sumNotIncluded + this.otherNotIncluded;
      this.informationData.sumBudget = this.sumBudget + this.otherNotIncluded;
      this.informationData.sumNotBudget = this.sumNotBudget + this.otherNotIncluded;

      this.decideContract(this.checkTableData, val);
    },
  },
  mounted() {
    //this._supplierPortOperationPageList();
  },
  methods: {
    // 导出数据
    exportData() {
      let token = getSessionStore('token');
      const exportParams = {
        ...this.form,
        startDate: this.operationDate ? this.operationDate[0] : '',
        endDate: this.operationDate ? this.operationDate[1] : '',
      }
      window.exportExcel(`${baseUrl}/platform/settlement/supplierPortOperation/exportXls?access_token=${token}`, exportParams, '供应商港口操作费结算');
    },
    async _supplierPortOperationPageList() {
      this.tableLoad = true;
      const res = await supplierPortOperationPageList({
        ...this.form,
        startDate: this.operationDate ? this.operationDate[0] : '',
        endDate: this.operationDate ? this.operationDate[1] : '',
      });
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableDatas = res.data.records;
      this.total = res.data.total;
    },
    // 抵扣费用下拉
    async _deductionInvoicingCostGetAllByCompanyId(id) {
      const res = await deductionInvoicingCostGetAllByCompanyId(id);
      if (res.status !== 0) return this.$message.error(res.message);
      this.InvoicingList = res.data.map(item => ({
        id: item.id,
        deductionNum: item.deduction_num,
        remainingDiscountAmount: item.remaining_discount_amount,
      }));
    },
    // 生成对账单
    async _customerAdd() {
      const {
        supplier,
        sumIncluded,
        sumNotIncluded,
        title,
        isInvoicing,
        Invoicing,
        Deductible,
        remark,
        sumBudget,
        sumNotBudget,
      } = this.informationData;
      let settIds = '';
      // 作业费用id逗号拼接
      this.checkTableData.forEach((item, index) => {
        // 最后一个不加逗号
        settIds += index === this.checkTableData.length - 1 ? item.id : `${item.id},`;
      });
      let otherCostIds = '';
      // 其他费用逗号拼接
      this.otherTableData.forEach((item, index) => {
        // 最后一个不加逗号
        otherCostIds += index === this.otherTableData.length - 1 ? item.id : `${item.id},`;
      });
      const obj = {
        companyId: this.consignorId,
        companyNameOld: this.oldSupplier,
        companyNameNew: supplier,
        settType: this.settlement,
        taxPrice: Number(sumIncluded),
        noTaxPrice: Number(sumNotIncluded),
        taxSettPrice: sumBudget,
        noTaxSettPrice: sumNotBudget,
        title,
        isDeduct: isInvoicing,
        deductId: Invoicing.id,
        deductAmount: Deductible,
        remark,
        type: 6, // 操作费结算
        settIds: this.checkTableData.length > 0 ? settIds : '',
        otherCostIds: this.otherTableData.length > 0 ? otherCostIds : '',
      };
      const res = await customerAdd(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      await this._supplierPortOperationPageList();
      this.dialogClose();
      await this._supplierPortOperationPageList();
    },
    // 生成对账单按钮
    addBtn() {
      if (this.checkTableData.length <= 0) return this.$message.warning('请至少选择一条结算数据！');

      let supplierFlag = false; // 供应商
      let taxFlag = false; // 税率
      let reconciliationFlag = false; // 是否生成对账单
      if (this.checkTableData.length > 0) {
        const {
          supplierId,
          taxRate,
        } = this.checkTableData[0];
        this.checkTableData.forEach((item) => {
          if (item.supplierId !== supplierId) {
            supplierFlag = true;
          }
          if (item.taxRate !== taxRate) {
            taxFlag = true;
          }
          if (item.isReconciliation) {
            reconciliationFlag = true;
          }
        });
      }
      if (supplierFlag) return this.$message.warning('只能选择同一家供应商数据！');
      if (taxFlag) return this.$message.warning('部分数据税率不相等！');
      if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');

      this.$confirm('请选择结算方式', '提示', {
        confirmButtonText: '合同价',
        cancelButtonText: '预结算',
        distinguishCancelAndClose: true,
        type: 'warning',
      })
        .then(() => {
          let type = false;
          this.checkTableData.forEach((item) => {
            if (!item.taxContractPrice || item.taxContractPrice == '' || !item.contractPrice || item.contractPrice == '') {
              type = true;
            }
          });
          if (type) return this.$message.warning('操作失败，部分数据未拥有预结算价！');
          this.settlement = 1;
          // 生成对账单弹窗显示
          this.addFlag = true;
          this.$nextTick(() => {
            this.$refs.accountState.init(this.checkTableData);
          });
          // 判断是否是导入生成对账单
          this.importShow = false;
          this.informationData.supplier = this.TableDatas[0].portName;
        })
        .catch((action) => {
          if (action == 'close') return;
          let type = false;
          let state = false;
          this.checkTableData.forEach((item) => {
            if (item.taxContractPrice && item.taxContractPrice != '' && item.contractPrice && item.contractPrice != '') {
              type = true;
            }
          });
          if (type) return this.$message.warning('部分数据只能使用合同价！');
          this.checkTableData.forEach((item) => {
            if (!item.taxPreparePrice || item.taxPreparePrice == '' || !item.preparePrice || item.preparePrice == '') {
              state = true;
            }
          });
          if (state) return this.$message.warning('操作失败，部分数据未拥有预结算价！');
          this.settlement = 2;
          // 生成对账单弹窗显示
          this.addFlag = true;
          this.$nextTick(() => {
            this.$refs.accountState.init(this.checkTableData);
          });
          // 判断是否是导入生成对账单
          this.importShow = false;
          this.informationData.supplier = this.TableDatas[0].portName;
        });
    },
    // 刷新结算按钮
    async addResetBtn() {
      // if (!this.form.workType) return this.$message.warning('请选择作业类型后刷新结算！');
      this.tableLoad = true;
      const {
        status,
        message,
      } = await operationRefreshSettlement(this.form.workType);
      this.tableLoad = false;
      status === 0 ? this.$message.success(message) : this.$message.error(message);
      console.log(status, message);
    },
    searchBtn() {
      this.form.page = 1;
      this._supplierPortOperationPageList();
    },
    resetBtn() {
      for (const argumentsKey in this.form) {
        this.form[argumentsKey] = '';
      }
      this.form.page = 1;
      this.form.rows = 10;
      this.operationDate = ['', ''];
    },
    contractSizeChange(row) {
      this.form.rows = row;
      this._supplierPortOperationPageList();
    },
    contractCurrentChange(page) {
      this.form.page = page;
      this._supplierPortOperationPageList();
    },

    getSummaries(param) {
      const {
        columns,
        data,
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
        } else if (index >= 11) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => prev + curr, 0);
          }
          console.log(column);
        }
      });
      return sums;
    },
    // 导入
    importClick(index, row) {
      if (this.checkList.length < 0) return this.$message.warning('至少选择三个条件');
      this.visible = false;
      this.importShow = true;
      this.addFlag = true;
    },
    rowStyle({ row }) {
      return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    // 多选事件触发
    handleCurrentChange(val) {
      if (!this.tipOne) {
        this.tipOne = true;
        this.checkTableData = [];
        this.$refs.multipleTable.clearSelection();
      } else {
        this.checkTableData = val;

        let Waybill = '';
        const array = val.filter((item, index) => {
          if (index === 0) Waybill = item.portName;
          return Waybill !== item.portName;
        });
        console.log(Waybill, array);
        // 筛选  供应商相同数据
        this.checkTableData = val.filter(item => Waybill === item.portName);
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          if (this.tipOne) {
            this.$message.warning('只能选择相同的港口！');
            this.tipOne = false;
          }
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });
      }

      // this.$refs.accountState.calculation()
    },
    handleCurrentChangeAll(val) {
      this.checkTableData = val;
      console.log(val);
      console.log(this.checkTableData);

      // this.$refs.accountState.calculation()
    },
    tableRowClassName({row}) {
      if (this.sumContract !== this.sumNotIncluded && this.importShow) return 'ui-warning-row';
      return '';
    },
    // 作业费用 多选表格联动 主页面重新勾选
    selectChange() { // 勾选
      // 先清空选择
      this.$refs.multipleTable.clearSelection();
      this.$nextTick(() => {
        // 已选择费用 循环id 相同勾选
        this.checkTableData.forEach((row) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
        });
      });
    },
    dialogClose() {
      this.activeName = 'information';
      this.addFlag = false;// 关闭窗口
      // 清空
      for (const informationDataKey in this.informationData) {
        this.informationData[informationDataKey] = '';
      }
      // 清除提示
      this.$refs.ruleForm.resetFields();
    },
    calculation(table, zi) {
      let sum = 0;
      table.forEach((item, index) => {
        sum += Number(item[zi]);
        console.log(sum);
      });
      return sum;
    },
    // 1 作业车辆操作 2其他费用
    deleteClick(index, flag) {
      if (flag === 1) {
        const array = this.checkTableData.splice(index, 1);

        array.forEach((item) => {
          this.notTableData.push(item);
        });
        console.log(this.notTableData);
        // 作业费用 多选表格联动 主页面重新勾选
        this.selectChange();
      } else {
        this.otherTableData.splice(index, 1);
        // 触发子组件 父组件子组件多选表格联动 重新勾选
        this.$refs.otherAdds.toggleSelection();
      }
    },
    otherAddClick() {
      this.consignorId = this.checkTableData.length > 0 ? this.checkTableData[0].portId : '';
      this.otherAddFlag = true;
      this.$nextTick(() => {
        this.$refs.otherAdds._othercostGetAllByCompanyId();
      });
    },
    otherData(value) {
      this.otherTableData = value;
    },
    addWaybill(index) {
      const a = this.notTableData.splice(index, 1);
      this.checkTableData.push(a[0]);
      // 作业费用 多选表格联动 主页面重新勾选
      this.selectChange();
    },
    //  判断 不/含税合同价是否为空  value  value2其他费用
    decideContract(value, value2) {
      let flag = true;
      for (const valueElement of value) {
        if (valueElement.taxContractPrice === null || valueElement.contractPrice === null) {
          // 是否禁用选项
          this.isDisabled = true;
          flag = false;
          console.log(this.isDisabled);
          this.settlement = 2;
          break;
        } else {
          flag = true;
        }
      }
      for (const value2Element of value2) {
        if (value2Element.costAmount === null || value2Element.excludingTaxAmount === null) {
          // 是否禁用选项
          this.isDisabled = true;
          flag = false;
          console.log(this.isDisabled);
          this.settlement = 2;
          // 终止foreach 并且不执行后面的代码
          break;
        } else {
          flag = true;
        }
      }

      if (flag) {
        this.isDisabled = false;
      }
    },
    selectable(row, index) {
      // 是否生成对账单 1：否 2：是  否 则不让勾选
      return row.isReconciliation === 1;
    },
    // 生产对账点 确认
    accountAdd() {
      if (this.checkTableData.length <= 0) return this.$message.warning('作业费用不能为空');
      if (this.otherTableData.length <= 0) return this.$message.warning('其他费用不能为空');
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this._customerAdd();
        } else {

        }
      });
    },
    // 是否抵扣开票
    isInvoicingChange(value) {
      const id = this.checkTableData.length > 0 ? this.checkTableData[0].portId : '';
      if (value === 1) {
        this._deductionInvoicingCostGetAllByCompanyId(id);
      }
    },

    // 修改台账月 -- 删除
    delLedger(index) {
      this.ledgerData.splice(index, 1);
    },
    // 修改台账月 -- 确认
    async ledgerChange() {
      const params = {
        standingBookMonth: this.ledger,
        consignorPortList: [],
      };
      this.ledgerData.forEach((res) => {
        params.consignorPortList.push({id: res.id});
      });
      await operationUpdateBookMonth(params)
        .then((res) => {
          if (res.status === 0) {
            this.$message.success(res.message);
            this.ledgerVisible = false;
            this._settlementPageList();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 修改台账月 -- 取消(关闭弹窗)
    ledgerClose() {
      this.ledger = '';
      this.ledgerData = [];
      this.ledgerVisible = false;
    },
    // 价格刷新
    async priceRefresh() {
      this.importLoading = true;
      const obj ={
        ...this.form,
        startDate: this.operationDate ? this.operationDate[0] : '',
        endDate: this.operationDate ? this.operationDate[1] : '',
      }
      const {
        status,
        message,
      } = await portOperatePriceRefreshRenovate(obj);
      this.importLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
    },
    // 修改台账月 -- 打开弹窗
    // ledgerRevise() {
    //   if (!this.checkTableData.length || this.checkTableData.length === 0) return this.$message.error('请选择至少一条数据！');
    //   if (this.checkTableData.length > 100) return this.$message.error('最多选择100条数据！');
    //   this.ledgerData = this.checkTableData;
    //   this.ledgerVisible = true;
    // },
    download(flag) {
      // flag ? window.location.href = '/file/港口对账模板.xlsx' : window.location.href = '/file/供应商导入模板（含结算方式）.xlsx';
      flag ? window.location.href = '/file/港口对账模板.xlsx' : window.location.href = '/file/供应商港口操作费导入模板.xls';
    },
    changeImportLoading(flag) {
      this.importLoading = flag;
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text')
        .replace(/\s/g, ',')
        .split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'frameNumber':
          this.form.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },
  },
};
</script>


<style lang='scss' scoped>
.operation {
  width: 100%;
  /*padding:20px 15px 0 25px;*/
  height: 100%;

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
    color: #606266;
    content: "全选";
    font-size: 12px;
    margin-left: 2px;

  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;

    .flex1 {
      flex: 1;
    }

    .el-input {
      width: 150px;
    }

    .el-select {
      width: 150px;
    }

    ::v-deep {
      label.el-form-item__label {
        line-height: 30px;
        font-weight: 500;
        color: #101010;
      }

      .el-form-item__content {
        line-height: 30px;
      }
    }
  }

  ::v-deep.content {
    .el-table th > .cell {
      font-weight: 700 !important;
    }

    .el-table .cell, .el-table td {
      padding: 0;
    }
  }

  ::v-deep .importBill {
    width: 100%;
    padding: 10px 16px 20px 20px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .el-table td, .el-table th {
      padding: 0;
    }

    .el-tabs__item.is-active {
      color: #335483
    }

    .el-tabs__item {
      font-weight: bold !important;
    }

    cell {
      font-size: 10px;
      padding: 0;
    }

    .el-table .ui-warning-row {
      background-color: #fef0f0 !important;
    }

    .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
      background-color: #fef0f0 !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .information {
      /*width: 83%;*/
      .el-form-item__label {
        font-weight: 700;
      }

      .el-input {
        width: 56%;
      }

      .el-form-item {
        margin-bottom: 9px;
      }

      .costList {
        .el-input {
          width: 100%;
        }
      }

      .icon {
        color: red;
        font-size: 20px;
        margin-left: 20px;

        span {
          font-size: 15px;
        }
      }

    }

    .cost {
      .iconError {
        font-size: 20px;

        i:hover {
          color: #00e1ff;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding-right: 20px;

        .el-button--mini {
          padding: 4px 4px;
        }
      }
    }

    .otherCost {
      .total {
        .otherAdd {
          color: rgba(51, 136, 255, 1);
          text-align: right;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }


}

::v-deep {

  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
    overflow: auto;
    max-height: 75vh;
    color: #606266;
  }

  .el-form--inline .el-form-item {
    margin-bottom: 5px;
  }

}

.operation .importBill .operation {
  margin-top: 0px !important;
  padding: 0px;
}

.operation .importBill .operationTable {
  padding-right: 0px !important;
}

.ledger {
  padding: 20px;
  max-height: calc(70vh - 60px);
  overflow-y: auto;

  .leader-input {
    display: inline-block;
    width: 100%;
    margin-bottom: 15px;

    span {
      display: inline-block;
      width: 100px;
    }

    ::v-deep {
      .el-input.el-input--small {
        display: inline-block;
        width: 200px;
      }
    }
  }

  span.dialog-footer {
    display: inline-block;
    width: 100%;
    padding: 20px 0 10px;
    text-align: center;
  }

  ::v-deep {
    .el-table td {
      padding: 5px;
    }

    .el-table td, .el-table th {
      font-size: 13px;
      padding: 5px;
    }
  }
}

::v-deep {
  .buttonClass {
    .el-form-item__content {
      display: inline-flex;
    }
  }
}
</style>
